"use client";
import { useEffect } from "react";
import "../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../Chrome/BrowseContext/hook.js";
import { airgapIntegration } from "../../Chrome/BrowseContext/airgapIntegration.js";
import { createConsentHandler, restoreConsent, syncOTConsent } from "./lib.js";
import { COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY, COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON } from "../constants.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage/index.js";
const SalesTargetingClient = ({
  isTranscendCookieMonitoringEnabled
}) => {
  const browseContext = useBrowseContext();
  const [consentProviderSessionStorage] = useSessionStorage(
    COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY,
    isTranscendCookieMonitoringEnabled
  );
  const isTranscendActive = isTranscendCookieMonitoringEnabled || consentProviderSessionStorage === COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON;
  useEffect(() => {
    if (!isTranscendActive) {
      return;
    }
    const handleAirgapLoadEventReady = async (event) => {
      if (!(event instanceof CustomEvent)) {
        console.error("Expected CustomEvent for airgapLoadEventReady");
        return;
      }
      if (window == null ? void 0 : window.airgapLoadEvent) {
        await restoreConsent(
          window.airgapLoadEvent,
          process.env.NEXT_PUBLIC_SITE || ""
        );
      }
    };
    if (window == null ? void 0 : window.airgapLoadEvent) {
      handleAirgapLoadEventReady({});
    } else {
      window.addEventListener(
        "airgapLoadEventReady",
        handleAirgapLoadEventReady
      );
    }
    return () => {
      window.removeEventListener(
        "airgapLoadEventReady",
        handleAirgapLoadEventReady
      );
    };
  }, [isTranscendActive]);
  useEffect(() => {
    var _a, _b;
    if (!isTranscendActive) {
      return;
    }
    const handleConsentChange = ({
      detail: { consent }
    }) => {
      syncOTConsent(consent);
      const consentManagementState = browseContext.thirdPartyInfo.consentManagement;
      const airgapState = airgapIntegration.read();
      if (consentManagementState.isTargetingEnabled !== airgapState.isTargetingEnabled) {
        window.location.reload();
      }
    };
    (_b = (_a = window.airgap) == null ? void 0 : _a.addEventListener) == null ? void 0 : _b.call(
      _a,
      "consent-change",
      createConsentHandler(handleConsentChange)
    );
    return () => {
      var _a2, _b2;
      (_b2 = (_a2 = window.airgap) == null ? void 0 : _a2.removeEventListener) == null ? void 0 : _b2.call(
        _a2,
        "consent-change",
        createConsentHandler(handleConsentChange)
      );
    };
  }, [isTranscendActive, browseContext.thirdPartyInfo.consentManagement]);
  return null;
};
export {
  SalesTargetingClient
};
